import { render } from "./MetaCmp.vue?vue&type=template&id=be608610"
import script from "./MetaCmp.vue?vue&type=script&lang=js"
export * from "./MetaCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__